import { LinkCardGrid } from "../../elements/LinkCardGrid";
import { usePageState } from "../../context/usePageState";
import { getVisibleSettingsLinks } from "./settingsLinkItems";

/** A card for each settings page the user may open. */
export function SettingsLinks() {
  const { hasAnyRole } = usePageState();

  return <LinkCardGrid items={getVisibleSettingsLinks(hasAnyRole)} />;
}

export default SettingsLinks;
